module.exports = __webpack_public_path__ + "static/es-32afb075f34c626b653bb93ed4a1db4e.svg";